// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Data Model Store
 */
import { observable, observe, action } from 'mobx';
import QuerySourceTypeStore from 'logic/Izenda.QuerySourceTypeStore';
import RelationshipStore from './Izenda.RelationshipStore';
import fetcher from 'fetchers/Izenda.DataModelDataFetcher';
import uiState from './Izenda.UiState';
import { MENU, QUERY_SOURCE_TYPE } from 'logic/data/Izenda.DataModelConstants';
import { find } from 'lodash/fp';

export default class DataModelStore {
  constructor() {
    this.dataModelMenu = MENU;

    this.querySourceType = new QuerySourceTypeStore();
    this.relationship = new RelationshipStore();
  }

  @observable activeLink = QUERY_SOURCE_TYPE.TABLE;

  @observable indicator = [];

  /**
   * observe to uiState
   */
  init() {
    this.loadIndicator();
    !this.disposeObserveTenantID &&
      (this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
        this.loadIndicator();
      }));
  }

  /**
   * dispose observe
   */
  destroy() {
    this.disposeObserveTenantID && this.disposeObserveTenantID();
    this.disposeObserveTenantID = null;
  }

  /**
   * Update active Link
   */
  @action
  changeSelectItem(newLink) {
    this.activeLink = newLink;
  }

  /**
   * Load indicator for data model types
   */
  loadIndicator() {
    const afterLoadIndicator = result => {
      this.indicator = result;
      return null;
    };
    return fetcher.loadIndicator(uiState.getTenantId()).then(afterLoadIndicator);
  }

  /**
   * Load indicator for a data model type by its backendType
   */
  loadItemIndicator(backendType) {
    const marchingItem = find(o => o.key === backendType, this.indicator);

    return marchingItem && marchingItem.value;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.DataModelStore.js